import { Skeleton, TableCell, TableRow } from "@mui/material";

type TableSkeletonRowsProps = {
  rowCount: number;
  leftColumnCount: number;
  rightColumnCount: number;
  isDraggable: boolean;
  renderSpacer: boolean;
};

export const TableSkeletonRows = ({
  rowCount,
  leftColumnCount,
  rightColumnCount,
  isDraggable,
  renderSpacer,
}: TableSkeletonRowsProps) => (
  <>
    {Array.from({ length: rowCount }).map((_, rowIndex) => (
      <TableRow key={`skeleton-row-${rowIndex}`}>
        {isDraggable && <TableCell className="w-8 p-0" />}

        {Array.from({ length: leftColumnCount }).map((__, cellIndex) => (
          <TableCell key={`skeleton-left-${rowIndex}-${cellIndex}`} className="px-4 py-3">
            <Skeleton variant="text" />
          </TableCell>
        ))}

        {renderSpacer && <TableCell />}

        {Array.from({ length: rightColumnCount }).map((__, cellIndex) => (
          <TableCell key={`skeleton-right-${rowIndex}-${cellIndex}`} className="px-4 py-3">
            <Skeleton variant="text" />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);
